import { writable } from 'svelte/store';
export const ADDRESS_STORE = writable({});
export const ADDRESS_HASH = writable('initial');
